<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">คำขอต่ออายุบัตรผู้ประเมินหลัก</h1>
          <p class="page-subtitle">ระบบจัดการคำขอต่ออายุบัตรผู้ประเมินหลัก VAT</p>
        </div>

        <!-- Mock Data Warning -->
        <ngb-alert *ngIf="showMockDataWarning" type="info" [dismissible]="false" class="mb-3">
          <strong>ข้อมูลตัวอย่าง:</strong>
          ระบบกำลังใช้ข้อมูลตัวอย่างเนื่องจากไม่สามารถเชื่อมต่อ backend API ได้
        </ngb-alert>

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button type="button" class="clear-filters-btn" (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>

          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input type="text" class="form-control" [(ngModel)]="filters.searchTerm" (ngModelChange)="applyFilters()"
                placeholder="ชื่อ, เลขที่คำขอ หรือ ID Card">
            </div>

            <!-- Request No -->
            <div class="filter-group">
              <label class="form-label">เลขที่คำขอ</label>
              <input type="text" class="form-control" [(ngModel)]="filters.requestNo" (ngModelChange)="applyFilters()"
                placeholder="เลขที่คำขอ">
            </div>

            <!-- ID Card No -->
            <div class="filter-group">
              <label class="form-label">ID Card No.</label>
              <input type="text" class="form-control" [(ngModel)]="filters.idCardNo" (ngModelChange)="applyFilters()"
                placeholder="เลขบัตรประชาชน">
            </div>

            <!-- VAT Member Type -->
            <div class="filter-group">
              <label class="form-label">ประเภทสมาชิก VAT</label>
              <select class="form-select" [(ngModel)]="filters.vatMemberType" (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="ยังไม่มีบัตรสมาชิก">ยังไม่มีบัตรสมาชิก</option>
                <option value="วิสามัญ">วิสามัญ</option>
                <option value="สามัญ">สามัญ</option>
                <option value="ตลอดชีพ">ตลอดชีพ</option>
              </select>
            </div>

            <!-- Date From -->
            <div class="filter-group">
              <label class="form-label">วันที่เริ่มต้น</label>
              <input type="date" class="form-control" [(ngModel)]="filters.dateFrom" (ngModelChange)="applyFilters()">
            </div>

            <!-- Date To -->
            <div class="filter-group">
              <label class="form-label">วันที่สิ้นสุด</label>
              <input type="date" class="form-control" [(ngModel)]="filters.dateTo" (ngModelChange)="applyFilters()">
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button type="button" class="btn btn-outline-success" (click)="exportToCSV()"
              [disabled]="isExporting || filteredRequests.length === 0">
              <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isExporting" class="bi bi-file-earmark-excel me-2"></i>
              {{ isExporting ? 'กำลัง Export...' : 'Export CSV' }}
            </button>
            <button type="button" class="btn btn-primary" (click)="refreshData()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Status Tabs -->
        <div class="status-tabs mb-3" role="tablist" aria-label="สถานะการดำเนินการคำขอต่ออายุบัตรผู้ประเมิน">
          <button type="button" class="status-tab" *ngFor="let tab of statusTabs"
            [class.active]="isActiveStatusTab(tab)"
            [ngClass]="'status-tab-' + tab.color"
            role="tab" [attr.aria-selected]="isActiveStatusTab(tab)"
            (click)="selectStatusTab(tab)">
            <span class="status-tab-dot"></span>
            <span class="status-tab-name">{{ tab.name }}</span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="request-management-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลคำขอ...</p>
          </div>
        </div>

        <!-- Requests Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการคำขอต่ออายุ</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="sortable" (click)="sortBy('createdAt')"
                      [class.sorted]="isSortedBy('createdAt')" title="คลิกเพื่อเรียงลำดับ">
                      วันและเวลาที่ยื่นคำขอ {{ getSortIcon('createdAt') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('applicantName')"
                      [class.sorted]="isSortedBy('applicantName')" title="คลิกเพื่อเรียงลำดับ">
                      ชื่อ-นามสกุล {{ getSortIcon('applicantName') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('memberStatus')"
                      [class.sorted]="isSortedBy('memberStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะสมาชิก {{ getSortIcon('memberStatus') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('organization')"
                      [class.sorted]="isSortedBy('organization')" title="คลิกเพื่อเรียงลำดับ">
                      บริษัท/หน่วยงาน {{ getSortIcon('organization') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('appraiserLevel')"
                      [class.sorted]="isSortedBy('appraiserLevel')" title="คลิกเพื่อเรียงลำดับ">
                      ชั้นที่ขอต่ออายุ {{ getSortIcon('appraiserLevel') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('valuerId')"
                      [class.sorted]="isSortedBy('valuerId')" title="คลิกเพื่อเรียงลำดับ">
                      เลขที่ผู้ประเมินหลัก {{ getSortIcon('valuerId') }}
                    </th>
                    <th scope="col" class="text-center">เอกสารคำขอ</th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('reviewStatus')"
                      [class.sorted]="isSortedBy('reviewStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการตรวจสอบแบบคำขอ {{ getSortIcon('reviewStatus') }}
                    </th>
                    <th scope="col" class="text-end sortable" (click)="sortBy('feeAmount')"
                      [class.sorted]="isSortedBy('feeAmount')" title="คลิกเพื่อเรียงลำดับ">
                      จำนวนเงินที่ต้องชำระ {{ getSortIcon('feeAmount') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('paymentStatus')"
                      [class.sorted]="isSortedBy('paymentStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการชำระเงิน {{ getSortIcon('paymentStatus') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('paymentSlip')"
                      [class.sorted]="isSortedBy('paymentSlip')" title="คลิกเพื่อเรียงลำดับ">
                      หลักฐานการชำระเงิน {{ getSortIcon('paymentSlip') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('receiptStatus')"
                      [class.sorted]="isSortedBy('receiptStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการออกใบเสร็จ {{ getSortIcon('receiptStatus') }}
                    </th>
                    <th scope="col" class="text-center sortable" (click)="sortBy('processingStatus')"
                      [class.sorted]="isSortedBy('processingStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการดำเนินการ {{ getSortIcon('processingStatus') }}
                    </th>
                    <th scope="col">หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="!isLoading && getCurrentPageRequests().length === 0">
                    <td colspan="14" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูลคำขอ</p>
                        <small *ngIf="requests.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="requests.length > 0 && filteredRequests.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Request Rows -->
                  <tr *ngFor="let request of getCurrentPageRequests(); trackBy: trackByRequestId" class="clickable-row"
                    (click)="viewRequest(request)" title="คลิกเพื่อดูรายละเอียดคำขอ">
                    <!-- วันและเวลาที่ยื่นคำขอ -->
                    <td>{{ formatDateTime(request.createdAt) }}</td>

                    <!-- ชื่อ-นามสกุล -->
                    <td>{{ getApplicantName(request) }}</td>

                    <!-- สถานะสมาชิก -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="{
                          'bg-success': getMemberStatus(request) === 'Active',
                          'bg-danger': getMemberStatus(request) === 'หมดอายุ',
                          'bg-secondary': getMemberStatus(request) === 'ยังไม่มีบัตรสมาชิก'
                        }">{{ getMemberStatus(request) }}</span>
                    </td>

                    <!-- บริษัท/หน่วยงาน -->
                    <td>{{ getApplicantOrganization(request) }}</td>

                    <!-- ชั้นที่ขอ -->
                    <td class="text-center">
                      <span class="badge bg-info">{{ request.appraiserLevel || '-' }}</span>
                    </td>

                    <!-- เลขที่ผู้ประเมินหลัก -->
                    <td class="text-center">
                      <span class="font-monospace">{{ request.user.userInformation.valuerId || '-' }}</span>
                    </td>

                    <!-- เอกสารคำขอ (เข้าไปตรวจสอบและอนุมัติในหน้ารายละเอียด) -->
                    <td class="text-center">
                      <button type="button" class="btn btn-sm btn-primary"
                        (click)="$event.stopPropagation(); viewRequest(request)"
                        title="เปิดดูเอกสารคำขอและอนุมัติในหน้ารายละเอียด">
                        <i class="bi bi-search me-1"></i>ตรวจสอบคำขอ
                      </button>
                    </td>

                    <!-- สถานะการตรวจสอบแบบคำขอ -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getReviewStatusClass(request)">
                        {{ getReviewStatusText(request) }}
                      </span>
                    </td>

                    <!-- จำนวนเงินที่ต้องชำระ -->
                    <td class="text-end">{{ (request.feeAmount || 0) | number:'1.2-2' }} บาท</td>

                    <!-- สถานะการชำระเงิน -->
                    <td class="text-center">
                      <span class="badge bg-warning">{{ request.paymentStatus || '-' }}</span>
                    </td>

                    <!-- หลักฐานการชำระเงิน -->
                    <td class="text-center">
                      <button *ngIf="hasPaymentSlip(request)" type="button" class="btn btn-sm btn-outline-primary"
                        (click)="openPaymentSlip(request, $event)" title="ดูหลักฐานการชำระเงิน">
                        <i class="bi bi-receipt"></i>
                      </button>
                      <span *ngIf="!hasPaymentSlip(request)" class="text-muted">-</span>
                    </td>

                    <!-- สถานะการออกใบเสร็จ -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getReceiptStatusClass(request)">
                        {{ getReceiptStatusText(request) }}
                      </span>
                    </td>

                    <!-- สถานะการดำเนินการ -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getStatusBadgeClass(request.status)">
                        {{ getStatusText(request.status) }}
                      </span>
                    </td>

                    <!-- หมายเหตุ -->
                    <td>{{ request.remarks || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }}
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="collectionSize" [maxSize]="5"
                [rotate]="true" [boundaryLinks]="true" [size]="'sm'" (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
